function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.35355 4.64645C9.54882 4.84171 9.54882 5.15829 9.35355 5.35355L6.35355 8.35356C6.25979 8.44732 6.13261 8.5 6 8.5C5.86739 8.5 5.74021 8.44732 5.64645 8.35356L2.64645 5.35356C2.45118 5.15829 2.45118 4.84171 2.64645 4.64645C2.84171 4.45119 3.15829 4.45119 3.35355 4.64645L5.5 6.7929V1.5C5.5 1.22386 5.72386 1 6 1C6.27614 1 6.5 1.22386 6.5 1.5V6.79289L8.64645 4.64645C8.84171 4.45119 9.15829 4.45119 9.35355 4.64645Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9.99994C2.72386 9.99994 2.5 10.2238 2.5 10.4999C2.5 10.7761 2.72386 10.9999 3 10.9999H9C9.27614 10.9999 9.5 10.7761 9.5 10.4999C9.5 10.2238 9.27614 9.99994 9 9.99994H3Z"
  }));
};

export default SvgComponent;